// extracted by mini-css-extract-plugin
export default {"cancelNotification":"B8hkT","insideModal":"S2Ptb","noTopMargin":"_95g7w","canceledIcon":"Nj5O2"};